import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Keyboard, Navigation, Scrollbar } from "swiper/modules";
export function initSliderFullWidthNav(selector) {
    if (document.querySelector(selector)) {
        var swiper = new Swiper(selector, {
            modules: [Navigation, Keyboard, Scrollbar],
            slidesPerView: 1,
            centeredSlides: true,
            navigation: {
                nextEl: ".testimonial-next",
                prevEl: ".testimonial-prev",
            },
            scrollbar: {
                el: ".testimonial-scrollbar-container",
                enabled: true,
                draggable: true,
                hide: false,
            },
            initialSlide: 0,
            autoHeight: false,
            loop: false,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
        });
    }
}
